import { AccessDeniedComponent } from '../../core/access-denied/access-denied.component';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { BannerMessageComponent } from './banner-message/banner-message.component';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';
import { ContactInformationComponent } from './contact-information/contact-information.component';
import { CSVDownloadComponent } from './csv-download/csv-download.component';
import { PrimaryReporterComponent } from './primary-reporter/primary-reporter.component';
import { RadioSelectComponent } from './radio-select/radio-select.component';
import { SelectMultipleServicesComponent } from './select-multiple-services/select-multiple-services.component';
import { SelectSingleServiceComponent } from './select-single-service/select-single-service.component';
import { SessionExpiredComponent } from './session-expired/session-expired.component';

export const components = [
  BannerMessageComponent,
  CalendarHeaderComponent,
  ContactInformationComponent,
  PrimaryReporterComponent,
  RadioSelectComponent,
  SessionExpiredComponent,
  AccessDeniedComponent,
];

export const standaloneComponents = [
  AccordionItemComponent,
  CSVDownloadComponent,
  SelectSingleServiceComponent,
  SelectMultipleServicesComponent,
];

export * from './accordion-item/accordion-item.component';
export * from './banner-message/banner-message.component';
export * from './calendar-header/calendar-header.component';
export * from './contact-information/contact-information.component';
export * from './csv-download/csv-download.component';
export * from './export-snackbar/export-snackbar.component';
export * from './primary-reporter/primary-reporter.component';
export * from './radio-select/radio-select.component';
export * from './select-multiple-services/select-multiple-services.component';
export * from './select-single-service/select-single-service.component';
export * from './session-expired/session-expired.component';
